"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Cornering.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Cordless = function Cordless(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 197.5 197.5"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Line Icon Cornering"), _react2.default.createElement("g", {
    className: "cornering",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M99.4,0.1C44.9,0.1,0.6,44.4,0.6,98.9s44.2,98.8,98.8,98.8s98.8-44.2,98.8-98.8S153.9,0.1,99.4,0.1z M99.4,186.4c-48.4,0-87.6-39.2-87.6-87.6c0-48.4,39.2-87.6,87.6-87.6c48.4,0,87.6,39.2,87.6,87.6c0,0,0,0,0,0 C186.9,147.2,147.7,186.4,99.4,186.4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M138.1,103.2v-8.6h17.2v8.6H138.1z M112.3,103.2v-8.6h17.2v8.6H112.3z M69.3,103.2v-8.6h17.2v8.6H69.3z M43.5,103.2v-8.6h17.2v8.6H43.5z M95.1,129h8.6v17.2h-8.6V129z M95.1,103.2h8.6v17.2h-8.6V103.2z M95.1,77.4h8.6v17.2h-8.6V77.4z M95.1,51.6h8.6v17.2h-8.6V51.6z M73.6,73.1V38.7h8.6v34.4v8.6h-43v-8.6H73.6z M125.2,73.1h34.4v8.6h-34.4h-8.6v-43h8.6V73.1z M73.6,116.1h8.6v43h-8.6v-34.4H39.2v-8.6H73.6z M125.2,116.1h34.4v8.6h-34.4v34.4h-8.6v-43H125.2z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    },
    __self: undefined
  })));
};
exports.default = Cordless;